import { render, staticRenderFns } from "./settlementList.vue?vue&type=template&id=e3e54d70"
import script from "./settlementList.vue?vue&type=script&lang=js"
export * from "./settlementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports